import React from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import { isBoolean } from 'lodash';
import { customStyles } from '../helper';

export function DropDown(props) {
  const { placeHolder, rowIndex, colIndex, onChange, options, gridY, CustomAddEditAccess, isProductArchived, value } = props;
  const selectStyle = {
    ...customStyles,
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, fontSize: 12, opacity, transition };
    },
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      // height: "100%",
      height: '20px',
      borderBottom: '1px solid #848484',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
      fontSize: 12,
    }),
  };

  return (
    <FormGroup className="mb-0 flex-fill position-relative">
      <div className="custom-react-select-po">
        <Select
          options={options}
          getOptionLabel={(option) => `${option?.label}`}
          getOptionValue={(option) => `${option?.value}`}
          isDisabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          menuPlacement={gridY > 10 ? 'top' : 'bottom'}
          maxMenuHeight={150}
          styles={selectStyle}
          className="common-select"
          classNamePrefix="common-select"
          placeholder={placeHolder}
          value={value}
          onChange={(e) => onChange(e, rowIndex, colIndex)}
          isClearable
        />
      </div>
    </FormGroup>
  );
}
export default DropDown;
